import { Box, FormLabel, SystemStyleObject } from '@chakra-ui/react';
import { ChakraStylesConfig, Select } from 'chakra-react-select';
import { ReactNode } from 'react';

const chakraStyles: ChakraStylesConfig = {
    control: (provided, state) => ({
        ...provided,
        height: '40px',
        cursor: 'pointer',
    }),
    dropdownIndicator: (prev, { selectProps }) => ({
        ...prev,
        transform: `rotate(${selectProps.menuIsOpen ? -180 : 0}deg)`,
    }),
    menuList: (provided, state) => ({
        ...provided,
        borderRadius: '8px',
        boxShadow: '0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
        borderColor: 'gray.100',
        padding: '12px',
    }),
    option: (prev, state) => ({
        ...prev,
        height: '40px',
        color: state.isSelected ? 'brand.500' : undefined,
    }),
    // singleValue: (provided, state) => ({
    //     ...provided,
    //     color: 'red',
    // }),
};
export type TOption = { label: ReactNode | string; value: string };

export type TSelectMy = {
    label?: string;
    value: TOption;
    onChange: any;
    options: TOption[];
    sx?: SystemStyleObject;
    placeholder?: string;
};

const SelectMy = ({ label, value, onChange, sx, options, placeholder = 'Select...' }: TSelectMy) => {
    return (
        <Box sx={sx}>
            {label && (
                <FormLabel display="flex" fontSize="md" fontWeight="700" color="gray.900" mb="8px">
                    {label}
                </FormLabel>
            )}
            <Select
                className="my-select-select"
                placeholder={placeholder}
                selectedOptionStyle="check"
                options={options}
                variant="auth"
                value={value}
                onChange={onChange}
                chakraStyles={chakraStyles}
            />
        </Box>
    );
};

export default SelectMy;
